function r() {
  var r = new Map();
  return function (e, t) {
    try {
      var _n = function _n(n) {
        if (i) return n;
        var o = r.get(e.did);
        return void 0 !== o ? o : Promise.resolve(t()).then(function (t) {
          return r.set(e.did, t), t;
        });
      };

      var i = !1;

      var o = function () {
        if (e.params && "true" === e.params["no-cache"]) return i = !0, Promise.resolve(t());
      }();

      return Promise.resolve(o && o.then ? o.then(_n) : _n(o));
    } catch (r) {
      return Promise.reject(r);
    }
  };
}

function e(r, e) {
  return e();
}

var t = new RegExp("^did:([a-zA-Z0-9_]+):([a-zA-Z0-9_.-]+(:[a-zA-Z0-9_.-]+)*)((;[a-zA-Z0-9_.:%-]+=[a-zA-Z0-9_.:%-]*)*)(/[^#?]*)?([?][^#]*)?(#.*)?$");

function i(r) {
  if ("" === r || !r) throw new Error("Missing DID");
  var e = r.match(t);

  if (e) {
    var i = {
      did: "did:" + e[1] + ":" + e[2],
      method: e[1],
      id: e[2],
      didUrl: r
    };

    if (e[4]) {
      var n = e[4].slice(1).split(";");
      i.params = {};

      for (var o = 0, a = n; o < a.length; o += 1) {
        var s = a[o].split("=");
        i.params[s[0]] = s[1];
      }
    }

    return e[6] && (i.path = e[6]), e[7] && (i.query = e[7].slice(1)), e[8] && (i.fragment = e[8].slice(1)), i;
  }

  throw new Error("Invalid DID " + r);
}

var n = function n(t, i) {
  void 0 === t && (t = {}), this.registry = t, this.cache = !0 === i ? r() : i || e;
};

n.prototype.resolve = function (r) {
  var e = this;

  try {
    var t = i(r),
        n = this.registry[t.method];
    return n ? this.cache(t, function () {
      return n(t.did, t, e);
    }) : Promise.reject(new Error("Unsupported DID method: '" + t.method + "'"));
  } catch (r) {
    return Promise.reject(r);
  }
};

export { r as inMemoryCache, e as noCache, i as parse, n as Resolver };